import { type MutationHookOptions, useMutation } from '@apollo/client';
import { useCallback } from 'react';
import type { DeletePlace, DeletePlaceVariables } from 'types/graphql';

const DELETE_PLACE = gql`
  mutation DeletePlace($id: Int!) {
    deletePlace(id: $id) {
      id
    }
  }
`;

/** `deletePlace` on the DeletePlace document; the caller's options pass through untouched. */
export function useDeletePlace(options?: MutationHookOptions<DeletePlace, DeletePlaceVariables>) {
  const [mutate, { loading, error }] = useMutation<DeletePlace, DeletePlaceVariables>(DELETE_PLACE, options);
  const remove = useCallback((id: number) => mutate({ variables: { id } }), [mutate]);
  return { remove, loading, error };
}
